"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderingType = void 0;
// NOTE: Please update the README.md in shared/questionnaire-engine if this is modified.
var RenderingType;
(function (RenderingType) {
    RenderingType["web"] = "web";
    RenderingType["pdf"] = "pdf";
    RenderingType["proSummary"] = "proSummary";
    RenderingType["consumerSummary"] = "consumerSummary";
})(RenderingType || (exports.RenderingType = RenderingType = {}));
